// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer-module--wrapper--1GA4V","left":"Footer-module--left--3DeHe","middle":"Footer-module--middle--3-LCx","right":"Footer-module--right--2DywL"};